<template>
  <div class="install-pc">
    <div class="figure"></div>
    <div class="content">
      <div class="install-title">{{ $t('welfare_title_install_pc') }}</div>
      <div class="install-subtitle">{{ $t('welfare_subtitle_install_pc') }}</div>
      <div class="gift-code-txt">{{ $t('welfare_pc_gift_key') }}</div>
      <div class="gift-code" @click="doCopy('PLAYSOSONPC')">
        {{ $t('welfare_pc_gift_code') }}
        <div class="copy-btn"></div>
      </div>
      <div class="rule">{{ $t('welfare_pc_gift_code_rule') }}</div>
      <div class="award"></div>
      <div class="btn" @click="installPc">
        <div class="icon"></div>
        <div class="txt">
          <div class="t">PLAY ON PC</div>
          <div class="b">ONLY FOR WINDOWS</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const INSTALL_PC_LOCAL_KEY = 'ss_webgame_ist_pc'
export default {
  name: 'InstallPC',
  created () {
    const isShown = window.localStorage.getItem(INSTALL_PC_LOCAL_KEY)
    this.$emit('setDot', !isShown)
  },
  methods: {
    doCopy (value) {
      this.$toast.success(this.$t('copy_success'))
      this.$utils.copyToClipboard(value)
    },
    installPc () {
      window.localStorage.setItem(INSTALL_PC_LOCAL_KEY, 1)
      this.$emit('setDot', false)
      this.$utils.log('download_pc', { download_channel: 'reward_center' })
      window.open(`https://sos-pc.kingsgroupgames.com/dlfile/?clickcode=${this.$utils.clickInfo().clickcode || 'webgame'}`, '_blank')
    }
  }
}
</script>

<style lang='scss' scoped >
.install-pc {
  width: calc(1400 * var(--unit-px));
  height: calc(840 * var(--unit-px));
  background: url(~@/assets/img/welfare/bg_install_pc.jpg) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  margin-right: calc(55 * var(--unit-px));
  margin-top: calc(61 * var(--unit-px));
  .figure {
    width: calc(685 * var(--unit-px));
    height: calc(869 * var(--unit-px));
    position: absolute;
    bottom: 0;
    right: calc(-59 * var(--unit-px));
    z-index: 1;
    background: url(~@/assets/img/welfare/bg_install_pc_2.png) no-repeat center center;
    background-size: 100% 100%;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 3;
    width: calc(730 * var(--unit-px));
    left: calc(15 * var(--unit-px));
    top: calc(30 * var(--unit-px));
  }
  .install-title {
    font-size: calc(50 * var(--unit-px));
    font-weight: 600;
    color: #6F3A28;
    line-height: 1.44;
  }
  .install-subtitle {
    font-size: calc(24 * var(--unit-px));
    margin-top: calc(10 * var(--unit-px));
    height: calc(35 * var(--unit-px));
    color: #6F3A28;
    line-height: 1.46;
  }
  .gift-code-txt {
    font-size: calc(26 * var(--unit-px));
    margin-top: calc(22 * var(--unit-px));
    font-weight: 600;
    color: #FF5F0F;
    line-height: 1.2;
    text-shadow: -1px 1px 0px rgba(52,0,0,0.3);
  }
  .gift-code {
    cursor: pointer;
    font-size: calc(54 * var(--unit-px));
    font-weight: 600;
    color: #FF5F0F;
    line-height: 1.4;
    text-shadow: -1px 2px 0px rgba(52,0,0,0.5);
    position: relative;
  }
  .copy-btn {
    position: absolute;
    width: calc(30 * var(--unit-px));
    height: calc(30 * var(--unit-px));
    background: url(~@/assets/img/welfare/btn_copy.png) no-repeat center center;
    background-size: 100% 100%;
    bottom: 0;
    left: 100%;
  }
  .rule {
    font-size: calc(30 * var(--unit-px));
    margin-top: calc(10 * var(--unit-px));
    height: calc(44 * var(--unit-px));
    color: #42381B;
    line-height: 1.47;
  }
  .award {
    width: calc(467 * var(--unit-px));
    height: calc(306 * var(--unit-px));
    background: url(~@/assets/img/welfare/award_install_pc.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(40 * var(--unit-px));
  }
  .btn {
    width: calc(646 * var(--unit-px));
    height: calc(126 * var(--unit-px));
    background: url(~@/assets/img/welfare/bg_btn.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(26 * var(--unit-px));
    padding-bottom: calc(4 * var(--unit-px));
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: calc(90 * var(--unit-px));
    height: calc(90 * var(--unit-px));
    background: url(~@/assets/img/welfare/icon_windows.png) no-repeat center center;
    background-size: 100% 100%;
  }
  .txt {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: calc(16 * var(--unit-px));
  }
  .t {
    font-size: calc(42 * var(--unit-px));
    font-weight: 600;
    color: #473232;
    line-height: 1.5;
  }
  .b {
    font-size: calc(24 * var(--unit-px));
    font-weight: 600;
    color: #473232;
    line-height: 1.46;
  }
}
</style>
